import React from "react";
import { useSelector } from "react-redux";
import { fgfChildThemes } from "@theme/config/theme.config";

import Wrapper from "./push.styles";

export function Push() {
  const themeName = useSelector(state => state.StartUp.theme.themeName);
  const extendedFooterThemes = fgfChildThemes
  let customClass = '';
  if(extendedFooterThemes.includes(themeName)) {
    customClass = 'extend-footer';
  }
  
  return (
    <Wrapper className={customClass}></Wrapper>
  );
}
